import { Flex, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { To } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';

import { Typography } from '~/packages/common-frontend/components/Typography';

// Exports
type EntityNameProps = {
  isOnEntityRoute: boolean;
  label: React.ReactNode;
  to?: To;
  tooltipLabel: React.ReactNode;
};
export const EntityName = ({
  isOnEntityRoute,
  label,
  to,
  tooltipLabel,
}: EntityNameProps) => {
  return (
    <>
      {isOnEntityRoute && 'this '}
      <Tooltip
        openDelay={300}
        as="span"
        alignItems="flex-start"
        display="inline-flex"
        flexDirection="column"
        maxWidth="100%"
        label={
          <Flex
            as="span"
            direction="column"
            alignItems="baseline"
            flexGrow={1}
            maxWidth="80vw"
          >
            {tooltipLabel}
          </Flex>
        }
        shouldWrapChildren
      >
        {to && !isOnEntityRoute ? (
          <Typography
            inline
            variant="detail"
            fontWeight="semibold"
            TextProps={{ _hover: { textDecoration: 'underline' } }}
          >
            <RouterLink to={to}>{label}</RouterLink>
          </Typography>
        ) : (
          <Typography
            inline
            variant="detail"
            fontWeight="semibold"
            TextProps={{ userSelect: 'none' }}
          >
            {label}
          </Typography>
        )}
      </Tooltip>
    </>
  );
};
